const squirrelCup = [
    {
        path: '/winterGame/property',
        name: 'property',
        meta: {
            title: '道具箱'
        },
        component: () => import("@views/SquirrelCup/property.vue"),
    },
    {
        path: '/winterGame/property/details',
        name: "propertyDetails",
        meta: {
            title: "道具箱"
        },
        component: () => import("@views/SquirrelCup/propertyDetails.vue"),
    },
    {
        path: '/winterGame/weekly',
        name: "weekly",
        meta: {
            title: "时长周报"
        },
        component: () => import("@views/SquirrelCup/weekly.vue"),
    },
    {
        path: '/winterGame/weekly/details',
        name: "weeklyDetails",
        meta: {
            title: "时长周报"
        },
        component: () => import("@views/SquirrelCup/weeklyDetails.vue"),
    },
    {
        path: '/winterGame/extra',
        name: "extra",
        meta: {
            title: "加时卡"
        },
        component: () => import("@views/SquirrelCup/extra.vue"),
    },
    {
        path: '/winterGame/records',
        name: "records",
        meta: {
            title: "加时卡记录"
        },
        component: () => import("@views/SquirrelCup/records.vue"),
    },
    {
        path: '/winterGame/control',
        name: "controlList",
        meta: {
            title: "娱乐管控"
        },
        component: () => import("@views/SquirrelCup/controlList.vue"),
    },
    {
        path: '/winterGame/controlRecord',
        name: "controlRecord",
        meta: {
            title: "管控记录"
        },
        component: () => import("@views/SquirrelCup/controlRecord.vue"),
    },
    {
        path: '/winterGame/revive',
        name: "revive",
        meta: {
            title: "复活"
        },
        component: () => import("@views/SquirrelCup/revive.vue"),
    },
    {
        path: '/winterGame/rewardQuery',
        name: "rewardQuery",
        meta: {
            title: "奖励发放记录"
        },
        component: () => import("@views/SquirrelCup/rewardQuery.vue"),
    },
    {
        path: '/winterGame/daily',
        name: "daily",
        meta: {
            title: "松鼠杯日报"
        },
        component: () => import("@views/SquirrelCup/daily.vue"),
    },
]
export default squirrelCup;